import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'volunteering-overview-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-overview-tab-2.part.html',
})

export class VolunteeringOverviewTab2Part {
}
